import styled from 'styled-components';

import { ReactComponent as SortIcon } from '../../../assets/icons/sort-icon.svg';
import colors from '../../../styles/colors';
import Button from '../../Button';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledSortButton = styled(Button)`
  width: max-content;
  height: 30px;
  font-size: 10px;
  font-weight: 600;
  line-height: 12px;
  padding: 8px 12px;
  border-radius: 5px;
  background-color: ${colors.base.primary};
  cursor: pointer;
`;

const StyledSortIcon = styled(SortIcon)`
  width: 12px;
  height: 12px;
  margin-right: 6px;
  rotate: ${({ $isRecentFirst }) => ($isRecentFirst ? '180deg' : '0')};
`;

export {
  Container,
  StyledSortButton,
  StyledSortIcon,
};
